
(() => {
  const CART_QUERY_TRUE = 'interactive-cart[data-disable-delivery="true"]';
  const LOCK_TEXT = '配送日指定不可';

  const setAttr = (name, value) => {
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: { [name]: value } })
      });
    } catch (e) {}
  };

  const lockOne = (sel) => {
    if (!sel) return;

    sel.innerHTML = `<option value="${LOCK_TEXT}" selected>${LOCK_TEXT}</option>`;
    sel.value = LOCK_TEXT;
    sel.disabled = true;

    sel.dispatchEvent(new Event('change', { bubbles: true }));
    sel.dispatchEvent(new Event('input', { bubbles: true }));

    setAttr('配送希望日', LOCK_TEXT);

 
    if (!sel.dataset.observeChildren) {
      new MutationObserver(() => lockOne(sel)).observe(sel, { childList: true });
      sel.dataset.observeChildren = '1';
    }
  };

  const scanAndLock = (root = document) => {

    if (!document.querySelector(CART_QUERY_TRUE)) return;


    const known = root.querySelector('#deliveryDate, select[name="attributes[配送希望日]"]');
    if (known) { lockOne(known); return; }


    const labels = root.querySelectorAll('p,label,dt,h1,h2,h3,h4,h5,h6,span');
    for (const el of labels) {
      if ((el.textContent || '').includes('配送希望日')) {
        const near = el.nextElementSibling?.querySelector?.('select')
               || el.parentElement?.querySelector?.('select')
               || el.closest('div,li,fieldset')?.querySelector?.('select');
        if (near) { lockOne(near); break; }
      }
    }
  };


  [0,60,150,300,600,1000,1600].forEach(t => setTimeout(() => scanAndLock(), t));


  new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.addedNodes?.length) { scanAndLock(); break; }
      if (m.type === 'attributes' && m.attributeName === 'data-disable-delivery') { scanAndLock(); break; }
    }
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true });


  ['cart:updated','cart:update','cart:change','cart:refresh','product:added','cart-drawer:open','drawer:open','DOMContentLoaded','load']
    .forEach(ev => addEventListener(ev, () => scanAndLock(), true));
})();

// --- 設定 start ---
var minDay = 3;
var maxListSize = 5;
var limitTime = "14:00";
var timezoneoffset = -9;
var WeekChars = ["日", "月", "火", "水", "木", "金", "土"];
var noSendWeekDaylist = [''];
var noSendDaylist = [''];
var pullDownAddWeekDay = true;
var pullDownAddHead = true;
var pullDownAddHeadtxt = "指定無し";
var pullDownAddYear = true;
// --- 設定 end ---

var fakeUTC = new Date(Date.now() - (timezoneoffset * 60 - new Date().getTimezoneOffset()) * 60000);
var year = fakeUTC.getFullYear();
var month = fakeUTC.getMonth() + 1;
var date = fakeUTC.getDate();
var hour = fakeUTC.getHours();
var min = fakeUTC.getMinutes();

function waitForElement(selector, callback, interval = 100, timeout = 3000) {
  const startTime = new Date().getTime();
  const timer = setInterval(function () {
    const el = document.querySelector(selector);
    if (el) {
      clearInterval(timer);
      callback(el);
    } else if (new Date().getTime() - startTime > timeout) {
      clearInterval(timer);
      console.warn('Element not found: ', selector);
    }
  }, interval);
}

function initializeDeliveryDate() {
  var today = getToday();
  var now = getNow();
  var deadlineTime;

  try {
    var deadlineHour = limitTime.split(':')[0];
    var deadlineMinute = limitTime.split(':')[1];
    deadlineTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), deadlineHour, deadlineMinute);
  } catch (e) {
    console.log(e);
    deadlineTime = today;
  }

  if (now.getTime() > deadlineTime.getTime()) {
    minDay++;
  }

  var mimDay = new Date(now.setDate(now.getDate() + minDay));
  var selectList = createList(mimDay);

  if (noSendWeekDaylist.length > 0) {
    selectList = delSendWeekDay(selectList);
  }
  if (noSendDaylist.length > 0) {
    selectList = delSendDay(selectList);
  }

  createPullDown(selectList);
}

function delSendWeekDay(selectList) {
  var delAfterList = [];
  for (var i = 0; i < selectList.length; i++) {
    var skip = false;
    var wDay = selectList[i].getDay();
    for (var j = 0; j < noSendWeekDaylist.length; j++) {
      if (WeekChars[wDay] == noSendWeekDaylist[j]) {
        skip = true;
        break;
      }
    }
    if (!skip) delAfterList.push(selectList[i]);
  }
  return delAfterList;
}

function delSendDay(selectList) {
  var delAfterList = [];
  for (var i = 0; i < selectList.length; i++) {
    var skip = false;
    var targetDay = new Date(2001 + '/' + (selectList[i].getMonth() + 1) + '/' + selectList[i].getDate());
    for (var j = 0; j < noSendDaylist.length; j++) {
      var noSendDay = new Date(2001 + '/' + noSendDaylist[j]);
      if (targetDay.getTime() === noSendDay.getTime()) {
        skip = true;
        break;
      }
    }
    if (!skip) delAfterList.push(selectList[i]);
  }
  return delAfterList;
}

function createList(minDay) {
  var selectList = [];
  for (var i = 0; i < maxListSize; i++) {
    var targetDay = new Date(minDay);
    targetDay.setDate(targetDay.getDate() + i);
    selectList.push(targetDay);
  }
  return selectList;
}

function getToday() {
  return new Date(year + "/" + month + "/" + date);
}

function getNow() {
  return new Date(year + "/" + month + "/" + date + " " + hour + ":" + min);
}

function ketaume(num, digit) {
  return ('00' + num).slice(-digit);
}

function createPullDown(selectList) {
  var select = document.getElementById('deliveryDate');
  if (!select) return;
  select.innerHTML = ''; // clear existing

  var defaultVal = document.getElementById('dumyDeliveryDate')?.value || '';
  if (pullDownAddHead) {
    var option = document.createElement('option');
    option.value = '';
    option.innerHTML = pullDownAddHeadtxt;
    select.appendChild(option);
  }

  for (var i = 0; i < selectList.length; i++) {
    var option = document.createElement('option');
    var targetDate = ketaume(selectList[i].getMonth() + 1, 2) + '-' + ketaume(selectList[i].getDate(), 2);
    option.value = selectList[i].getFullYear() + '-' + targetDate;

    var label = '';
    if (pullDownAddYear) {
      label = selectList[i].getFullYear() + '/' + targetDate.replace(/-/g, '/');
    } else {
      label = targetDate.replace(/-/g, '/');
    }

    if (pullDownAddWeekDay) {
      var wDay = selectList[i].getDay();
      label += ' (' + WeekChars[wDay] + ')';
    }

    option.innerHTML = label;
    if (option.value === defaultVal) option.selected = true;
    select.appendChild(option);
  }
}

// 起動処理
waitForElement('#deliveryDate', function () {
  initializeDeliveryDate();
});
